import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const SsoCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { ssoLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [errorDetail, setErrorDetail] = useState<string | null>(null);

  useEffect(() => {
    const cpf = searchParams.get('cpf');
    const token = searchParams.get('token');

    if (!cpf || !token) {
      setError('Parâmetros de autenticação SSO inválidos.');
      setErrorDetail(`cpf: ${cpf ? 'presente' : 'ausente'}, token: ${token ? 'presente' : 'ausente'}`);
      return;
    }

    console.log('[SSO] Iniciando login SSO...', { cpf, tokenLength: token.length });

    ssoLogin(cpf, token)
      .then(() => {
        console.log('[SSO] Login SSO realizado com sucesso');
        navigate('/', { replace: true });
      })
      .catch((err) => {
        console.error('[SSO] Erro completo:', err);
        console.error('[SSO] err.message:', err?.message);
        console.error('[SSO] err.code:', err?.code);
        console.error('[SSO] err.response:', err?.response);
        console.error('[SSO] err.request:', err?.request);

        let detail = err?.message || 'Erro desconhecido';
        if (err?.response) {
          // Servidor respondeu com erro HTTP
          const data = err.response.data;
          detail = `HTTP ${err.response.status}: ${data?.message || JSON.stringify(data)}`;
        } else if (err?.request) {
          // Requisição foi feita mas sem resposta
          detail = `Sem resposta do servidor. URL: ${err?.config?.baseURL}${err?.config?.url}`;
        }

        setError('Falha na autenticação SSO.');
        setErrorDetail(detail);
      });
  }, []);

  if (error) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', gap: 2, p: 3 }}>
        <Typography color="error" variant="h6">{error}</Typography>
        {errorDetail && (
          <Typography variant="body2" sx={{ color: '#666', maxWidth: 600, textAlign: 'center', wordBreak: 'break-all' }}>
            {errorDetail}
          </Typography>
        )}
        <Button variant="outlined" onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', gap: 2 }}>
      <CircularProgress />
      <Typography>Autenticando via SSO...</Typography>
    </Box>
  );
};

export default SsoCallback;
